import { Alert } from '@tempmee/react';
import { FC } from 'react';
import { Box } from '~/commonComponents';

interface ITipBannerProps {
  visible: boolean;
  description: string;
  /** @default 'Tip:' */
  title?: string;
}

export const TipBanner: FC<ITipBannerProps> = ({ visible, description, title = 'Tip:' }) => {
  return (
    <Box
      data-testid="tip-banner-wrapper"
      data-cy="tip-banner-wrapper"
      maxHeight={visible ? 200 : 0}
      opacity={visible ? 1 : 0}
      overflow="hidden"
      transition="max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-bottom 0.3s ease-in-out"
      marginBottom={visible ? 16 : 0}
    >
      <Alert
        data-testid="tip-banner"
        data-cy="tip-banner"
        variant="info"
        title={title}
        description={description}
      />
    </Box>
  );
};
